import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart, DonutChart } from '../../../shared';
import { BAR_CHART_OPTIONS, DONUT_CHART_OPTIONS } from './constants';
import { XEVINAPANT_COMPANY_ID, colors } from '../../../../constants';

const EngagementDeciles = () => {
    const {
        isLoading, decileEngagementData, physicianEngagedBarChart 
    } = useSelector(state => state.digitalEngagement);
    const { categories, data } = physicianEngagedBarChart;
    const { company } = useSelector(state => state.company) || { company: {} };

    const [key, setKey] = useState(0);

    useEffect(() => {
        // Changing the key whenever the data changes
        setKey(prevKey => prevKey + 1);
    }, [isLoading, company, categories, data, decileEngagementData]);

    const barChartOptions = {
        ...BAR_CHART_OPTIONS,
        xaxis: {
            ...BAR_CHART_OPTIONS.xaxis,
            categories: categories
        }
    };

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Physician Engagement by Deciles
                </Typography>
            </Box>
            <Box className="wh-100" id="engagement-deciles">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : company.id === XEVINAPANT_COMPANY_ID ? (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={[{ name: 'Decile', data: data }]}
                        key={key} // Adding the key prop
                    />
                ) : (
                    <DonutChart
                        chartOptions={{
                            ...DONUT_CHART_OPTIONS,
                            labels: decileEngagementData.labels,
                            colors: colors
                        }}
                        chartSeries={decileEngagementData.series}
                        key={key} // Adding the key prop
                    />
                )}
            </Box>
        </Box>
    );
};

export default EngagementDeciles;
